import { IKnmDocumentsTableColumn } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmDocumentsTableColumn';

export const knmDocumentsTableColumns: IKnmDocumentsTableColumn[] = [
  {
    id: 'type',
    name: 'Тип',
  },
  {
    id: 'fileName',
    name: 'Наименование документа',
  },
  {
    id: 'dateCreate',
    name: 'Дата загрузки',
  },
  {
    id: 'signed',
    name: 'Статус подписания',
  },
];
